import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-add-user',
	templateUrl: './icon-add-user.component.svg',
})
export class IconAddUserComponent {}
